export const getModelDataColumns = (
  column: string,
): {
  title: string;
  dataIndex: string;
  key: string;
  validation?: { type: string; length?: number };
}[] => {
  switch (column) {
    case 'iccid':
      return [
        {
          title: 'ICCID',
          dataIndex: 'iccid',
          key: 'iccid',
          validation: { type: 'number', length: 20 },
        },
      ];
    case 'msisdn':
      return [
        {
          title: 'MSISDN',
          dataIndex: 'msisdn',
          key: 'msisdn',
          validation: { type: 'number' },
        },
      ];
    case 'imsi':
      return [
        {
          title: 'IMSI',
          dataIndex: 'imsi',
          key: 'imsi',
          validation: { type: 'number' },
        },
      ];
    case 'cpfcnpj':
      return [
        {
          title: 'CPF/CNPJ',
          dataIndex: 'cpfCnpj',
          key: 'cpfCnpj',
        },
      ];
    case 'deviceeui':
      return [
        {
          title: 'Device EUI',
          dataIndex: 'deviceEui',
          key: 'deviceEui',
        },
      ];
    case 'appeui':
      return [
        {
          title: 'App EUI',
          dataIndex: 'appEui',
          key: 'appEui',
        },
      ];
    default:
      return [];
  }
};

export const getModelData = (column: string) => {
  switch (column) {
    case 'msisdn':
      return [
        {
          key: '1',
          msisdn: '5534912345678',
        },
        {
          key: '2',
          msisdn: '5534912654892',
        },
        {
          key: '3',
          msisdn: '5534912345678',
        },
        {
          key: '4',
          msisdn: '5534912321895',
        },
      ];
    case 'imsi':
      return [
        {
          key: '1',
          imsi: '724320200047910',
        },
        {
          key: '2',
          imsi: '724320200047911',
        },
        {
          key: '3',
          imsi: '724320200047912',
        },
        {
          key: '4',
          imsi: '724320200047913',
        },
      ];
    case 'iccid':
      return [
        {
          key: '1',
          iccid: '89553201800009778610',
        },
        {
          key: '2',
          iccid: '89553201800009778611',
        },
        {
          key: '3',
          iccid: '89553201800009778612',
        },
        {
          key: '4',
          iccid: '89553201800009778613',
        },
      ];
    case 'cpfcnpj':
      return [
        {
          key: '1',
          cpfCnpj: '02118475000104',
        },
        {
          key: '2',
          cpfCnpj: '97506166000114',
        },
        {
          key: '3',
          cpfCnpj: '69041993000142',
        },
        {
          key: '4',
          cpfCnpj: '92018570000129',
        },
      ];
    case 'deviceeui':
    case 'appeui':
      return [
        {
          key: '1',
          deviceEui: 'asdas908283ikoas',
        },
        {
          key: '2',
          deviceEui: '1234opasd9032123',
        },
        {
          key: '3',
          deviceEui: 'jeu83ks61pa72kdh',
        },
        {
          key: '4',
          deviceEui: 'pa7dm2yf9ckqu15d',
        },
      ];
    default:
      return [];
  }
};
